import {createContext} from 'react'

export const VisibilityContext = createContext<boolean | null | undefined>(null)
